module.exports = __webpack_public_path__ + "img/adpoints-logo-w.ed7b357d.png";